import { Typography } from "@mui/material";
import theme from "../../assets/theme";

export default function TableData() {
  const roomBlockList = (data) => {

    return data.map((dt) => {
      return {
        request_id: dt.name,
        room_no: dt.room_name,
        reason: dt.reason,
        status: (
          <Typography
            sx={{
              backgroundColor: dt.status === "Active" ? theme.palette.green.main : theme.palette.red.main,
              color: "white",
              padding: "4px",
              borderRadius: "6px",
              minWidth: "110px",
              height:"30px",
              textAlign: "center",
              fontWeight: 500,
            }}
          >
            {dt.status}
          </Typography>
        ),
        from_date: dt.from_date,
        description: dt.description,
        to_date: dt.to_date,
        details: { ...dt },
      }
    });
  };

  return {
    roomBlockList,
    roomBlockHeader: [
      {
        id: 'request_id',
        label: 'Request ID',
        flex: 0.5,
        accessor: 'request_id',
        align: 'left',
      },
      {
        id: 'room_no',
        label: 'Room No.',
        flex: 0.5,
        accessor: 'room_no',
        align: 'center',
      },
      {
        id: 'reason',
        label: 'Reason',
        flex: 0.5,
        accessor: 'reason',
        align: 'center',
      },
      {
        id: 'status',
        label: 'Status',
        flex: 0.5,
        accessor: 'status',
        align: 'center',
      },
      {
        id: 'from_date',
        label: 'From Date',
        flex: 0.5,
        accessor: 'from_date',
        align: 'center',
      },
      {
        id: 'to_date',
        label: 'To Date',
        flex: 0.5,
        accessor: 'to_date',
        align: 'center',
      },
    ],
  };
}